// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color1: #1b3958;
  --primary-color2: #f15a48;
  --secondary-color1: #167997;
  --secondary-color2: #50c0ad;
  --secondary-color3: #c6e0ee;
  --tertiary-color2: #f27c2a;
  --neutral-color1: #d1d3d4;
  --neutral-color1-0p8: rgba(230, 231, 232, 0.9);
  --neutral-color2: #e6e7e8;
  --neutral-color3: #f1f2f2;
  --secondary-color3-zpf: rgba(198, 224, 238, 0.5);
  --www-color-float-bg1: #e0eef7;
  --www-color-float-bg2: #c6e1f0;
  --www-color-float-fg1: #1b3958;
  --risk-container: rgba(255, 255, 255, 0.75);
  --risk-item: #e6e7e8;
  --risk-item-0: #fcc021;
  --risk-item-1: #f27c2a;
  --risk-item-2: #b42226;
  --acc-item-0: #f27c2a;
  --acc-item-1: #fcc021;
  --acc-item-2: #50c0ad;
  --meteo-text: #167997;
}

:root {
  --mobile-nav-height: 14vh;
  --map-width: 95%;
}
body::-webkit-scrollbar {
  width: 0.3rem;
}

@keyframes scroll-from-top {
  0% {
    opacity: 0;
    transform: translateY(-50px);
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}
@keyframes rotate-layover {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes panel-open-from-left {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }
  90% {
    transform: translateX(-2%);
    opacity: 0.95;
  }

  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}
@keyframes scroll-from-bottom-left {
  0% {
    transform: translateY(100%);
    opacity: 0;
  }

  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/colors.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,8CAA8C;EAC9C,yBAAyB;EACzB,yBAAyB;EACzB,gDAAgD;EAChD,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,2CAA2C;EAC3C,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,UAAU;EACZ;AACF;AACA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,UAAU;EACZ;AACF","sourcesContent":[":root {\n  --primary-color1: #1b3958;\n  --primary-color2: #f15a48;\n  --secondary-color1: #167997;\n  --secondary-color2: #50c0ad;\n  --secondary-color3: #c6e0ee;\n  --tertiary-color2: #f27c2a;\n  --neutral-color1: #d1d3d4;\n  --neutral-color1-0p8: rgba(230, 231, 232, 0.9);\n  --neutral-color2: #e6e7e8;\n  --neutral-color3: #f1f2f2;\n  --secondary-color3-zpf: rgba(198, 224, 238, 0.5);\n  --www-color-float-bg1: #e0eef7;\n  --www-color-float-bg2: #c6e1f0;\n  --www-color-float-fg1: #1b3958;\n  --risk-container: rgba(255, 255, 255, 0.75);\n  --risk-item: #e6e7e8;\n  --risk-item-0: #fcc021;\n  --risk-item-1: #f27c2a;\n  --risk-item-2: #b42226;\n  --acc-item-0: #f27c2a;\n  --acc-item-1: #fcc021;\n  --acc-item-2: #50c0ad;\n  --meteo-text: #167997;\n}\n\n:root {\n  --mobile-nav-height: 14vh;\n  --map-width: 95%;\n}\nbody::-webkit-scrollbar {\n  width: 0.3rem;\n}\n\n@keyframes scroll-from-top {\n  0% {\n    opacity: 0;\n    transform: translateY(-50px);\n  }\n  30% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n}\n@keyframes rotate-layover {\n  0% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes panel-open-from-left {\n  0% {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  90% {\n    transform: translateX(-2%);\n    opacity: 0.95;\n  }\n\n  100% {\n    transform: translateX(0%);\n    opacity: 1;\n  }\n}\n@keyframes scroll-from-bottom-left {\n  0% {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateY(0%);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
